const RECHERCHE = {
    pageName: 'recherche',
    stringLength: 3,
    timeout: 500,
    urlParam: 'term',
};

export default RECHERCHE;
